import "vite/modulepreload-polyfill";
import { createRoot } from "react-dom/client";
import ContactWidget from "./Components/ContactWidget.jsx";

export function RenderContact(configuration){
    const container = document.getElementById(configuration.container);
    const root = createRoot(container);

    root.render(
      <div className="contact-widget-container">
        <ContactWidget config={configuration} />
      </div>
    );
}


document.addEventListener("DOMContentLoaded", function() {
    const widget_configs = document.querySelectorAll(".contact-widget-config");

    for (let config of widget_configs) {
        RenderContact(JSON.parse(config.innerText));
    }
});
